"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeCurrentTierDeclinedWarningModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var journey_services_1 = require("@athena-portal/journey-services");
var AnnualHomeCurrentTierDeclinedWarningModal = /** @class */ (function (_super) {
    __extends(AnnualHomeCurrentTierDeclinedWarningModal, _super);
    function AnnualHomeCurrentTierDeclinedWarningModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isTierWarningModalOpen: true
        };
        _this.toggle = _this.toggle.bind(_this);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        return _this;
    }
    AnnualHomeCurrentTierDeclinedWarningModal.prototype.render = function () {
        var _this = this;
        var quoteTier = this.props.interaction.uistate.previousCoverTier;
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggle });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.isTierWarningModalOpen, toggle: this.toggle, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { className: "mr-2 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon selected" }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: "Because of the changes you've made..." })] }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "pt-0", children: ["We can't offer you a quote for ", (0, jsx_runtime_1.jsx)("b", { children: this.tierDetail(quoteTier) }), ". You'll be able to choose your new cover level on the next page."] }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-flex", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: function (event) { return _this.handleOnClick(event); }, children: "Next" }) })] }));
    };
    AnnualHomeCurrentTierDeclinedWarningModal.prototype.tierDetail = function (tier) {
        switch (tier) {
            case services_1.BRONZE_TIER:
                return "Allianz Online Bronze Cover";
            case services_1.SILVER_TIER:
                return "Allianz Online Silver Cover";
            default:
                return "Allianz Online Gold Cover";
        }
    };
    AnnualHomeCurrentTierDeclinedWarningModal.prototype.toggle = function () {
        this.setState({
            isTierWarningModalOpen: !this.state.isTierWarningModalOpen,
        });
    };
    AnnualHomeCurrentTierDeclinedWarningModal.prototype.handleOnClick = function (event) {
        journey_services_1.ObjectManipulator.setField("uistate.currentTierDeclined", this.props.interaction, false);
        this.executeEvent('change');
        event.preventDefault();
    };
    return AnnualHomeCurrentTierDeclinedWarningModal;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeCurrentTierDeclinedWarningModal = AnnualHomeCurrentTierDeclinedWarningModal;
//# sourceMappingURL=AnnualHomeCurrentTierDeclinedWarningModal.js.map